'use client';

import { ChannelVerificationPage } from '@flipster/features/src/channel-verification-page';

const Page = () => {
  return <ChannelVerificationPage />;
};

export default Page;
